import * as tslib_1 from "tslib";
import { AssetEvent, AssetBase } from "@awayjs/core";
var AS2MCSoundProps = (function (_super) {
    tslib_1.__extends(AS2MCSoundProps, _super);
    function AS2MCSoundProps() {
        var _this = _super.call(this) || this;
        _this._volume = 1;
        _this._pan = 1;
        _this._changeEvent = new AssetEvent(AssetEvent.INVALIDATE, _this);
        return _this;
    }
    AS2MCSoundProps.prototype.dispose = function () {
        this._audio = null;
        this._changeEvent = null;
    };
    Object.defineProperty(AS2MCSoundProps.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (value) {
            if (this._volume != value) {
                this._volume = value;
                this.dispatchEvent(this._changeEvent);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AS2MCSoundProps.prototype, "pan", {
        get: function () {
            return this._pan;
        },
        set: function (value) {
            if (this._pan != value) {
                this._pan = value;
                this.dispatchEvent(this._changeEvent);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AS2MCSoundProps.prototype, "audio", {
        get: function () {
            return this._audio;
        },
        set: function (value) {
            if (this._audio)
                this._audio.stop();
            this._audio = value;
        },
        enumerable: true,
        configurable: true
    });
    return AS2MCSoundProps;
}(AssetBase));
export { AS2MCSoundProps };



// WEBPACK FOOTER //
// ../dist/lib/adapters/AS2MCSoundProps.js